module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.81bd542.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey/font/notokr-medium.woff
// module id = Og2/
// module chunks = 0